// CONTRACT_HISTORY_TABLE_QUERY_PARAM_PREFIX - prefix for query params, needed as there are multiple query params for different tables on the same page
export const CONTRACT_HISTORY_TABLE_QUERY_PARAM_PREFIX =
  "contract_history_" as const;
